/**
 * @author      Shivani Mehra
 * @date        Aug, 2024
 * @copyright   www.ibirdsservices.com
 */

import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import { toast } from "react-toastify"; //npm i react-toastify --force
import "react-toastify/dist/ReactToastify.css";
import TemplatePreview from "../whatsapp_template/TemplatePreview";
import jwt_decode from "jwt-decode";

// import moment from 'moment-timezone';

const CampaignTemplateModal = ({
  show,
  onHide,
  setshow,
  selectedWhatsAppSetting,
  setSelectedTemplateName,
  selectedTemplateName,
  tamplateparms,
  setTemplateParms,
}) => {
  const [userInfo, setUserInfo] = useState(
    jwt_decode(sessionStorage.getItem("token")),
  );
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [allTemplateData, setAllTemplateData] = useState([]);
  //  const [selectedTemplateName, setSelectedTemplateName] = useState();
  const [isSpinner, setIsSpinner] = useState(false);
  const categories = [
    "ALL",
    "UTILITY",
    "MARKETING",
    "IMAGE",
    "VIDEO",
    "DOCUMENT",
    "CAROUSEL",
    "NO_ATTACHMENT",
  ];
  const [parameters, setParameters] = useState({});
  const [buttonVariableValues, setButtonVariableValues] = useState({});

  useEffect(() => {
    // console.log("userInfo",userInfo)
    fetchAllTemplate(selectedWhatsAppSetting);
  }, [selectedWhatsAppSetting]);
  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);
    setSelectedTemplateName(null);

    let filtered = allTemplateData;

    if (category && category !== "ALL") {
      filtered = allTemplateData.filter((template) => {
        // Check by business category (MARKETING / UTILITY / AUTHENTICATION)
        if (["AUTHENTICATION", "UTILITY", "MARKETING"].includes(category)) {
          return template.category === category;
        }

        // Check by type of attachment
        if (category === "IMAGE") {
          return (
            template.header === "IMAGE" ||
            template.cards?.some((c) => c.header_type === "IMAGE")
          );
        }
        if (category === "VIDEO") {
          return (
            template.header === "VIDEO" ||
            template.cards?.some((c) => c.header_type === "VIDEO")
          );
        }
        if (category === "DOCUMENT") {
          return (
            template.header === "DOCUMENT" ||
            template.cards?.some((c) => c.header_type === "DOCUMENT")
          );
        }
        if (category === "CAROUSEL") {
          return template.template_type === "carousel";
        }

        // Check if parameterized (has {{}})
        if (category === "PARAMETERIZED") {
          return (
            template.message_body?.includes("{{") ||
            template.cards?.some((c) => c.body_text?.includes("{{"))
          );
        }

        // Templates without attachments
        if (category === "NO_ATTACHMENT") {
          return (
            (!template.header || template.header === "TEXT") &&
            !template.template_type &&
            !template.header_image_url &&
            !template.header_document_url &&
            !template.header_video_url
          );
        }

        return false;
      });
    }

    setFilteredTemplates(filtered);
  };

  const fetchAllTemplate = async (selectedWhatsAppSetting) => {
    const result = await WhatsAppAPI.getApprovedTemplates(
      selectedWhatsAppSetting,
    );

    if (result.error) {
      setAllTemplateData([]);
      setIsSpinner(true);
    } else {
      if (result?.data && result) {
        const transformedData = result?.data.map((row) => {
          const carouselComp = row.components.find(
            (component) =>
              component.type === "CAROUSEL" || component.type === "carousel",
          );
          const mainBody = row.components.find(
            (component) => component.type === "BODY",
          );

          if (carouselComp && Array.isArray(carouselComp.cards)) {
            // Map each card to a normalized structure
            const cards = carouselComp.cards.map((card) => {
              const header =
                card.components.find((c) => c.type === "HEADER") || {};
              const body = card.components.find((c) => c.type === "BODY") || {};
              const buttonsComp = card.components.find(
                (c) => c.type === "BUTTONS",
              );
              const buttons = buttonsComp?.buttons || [];

              const cardObj = {
                header_type: header.format || "",
                header_text: header.format === "TEXT" ? header.text : "",
                header_image_url:
                  header.format === "IMAGE"
                    ? header.example?.header_handle?.[0] || header.handle || ""
                    : "",
                header_document_url:
                  header.format === "DOCUMENT"
                    ? header.example?.header_handle?.[0] || ""
                    : "",
                header_video_url:
                  header.format === "VIDEO"
                    ? header.example?.header_handle?.[0] || ""
                    : "",
                body_text: body.text || "",
                body_text_example: body.example?.body_text?.[0] || [],
                buttons: buttons
                  .map((element) => ({
                    type: element.type,
                    text: element.text,
                    ...(element.type === "PHONE_NUMBER" && {
                      phone_number: element.phone_number,
                    }),
                    ...(element.type === "URL" && { url: element.url }),
                    example: element.example?.[0] || "",
                  }))
                  .filter((item) => item.text && item.type),
              };
              return cardObj;
            });

            const transformed = {
              id: row.id,
              name: row.name,
              templatename: row.name.replace(/_/g, " "),
              language: row.language,
              status: row.status,
              category: row.category,
              template_type: "carousel",
              message_body: mainBody?.text || "",
              example_body_text: mainBody?.example?.body_text || [],
              cards, // <-- This is the important part!
            };

            return transformed;
          }
          const header =
            row.components.find((component) => component.type === "HEADER") ||
            {};
          const body =
            row.components.find((component) => component.type === "BODY") || {};
          const footer =
            row.components.find((component) => component.type === "FOOTER") ||
            {};
          const buttons =
            row.components.find((component) => component.type === "BUTTONS")
              ?.buttons || [];

          return {
            id: row.id,
            name: row.name,
            templatename: row.name.replace(/_/g, " "),
            language: row.language,
            status: row.status,
            category: row.category,
            header: header.format || "",

            // Handling header types
            header_text: header.format === "TEXT" ? header.text : "",
            header_image_url:
              header.format === "IMAGE"
                ? header.example?.header_handle?.[0] || ""
                : "",
            header_document_url:
              header.format === "DOCUMENT"
                ? header.example?.header_handle?.[0] || ""
                : "",
            header_video_url:
              header.format === "VIDEO"
                ? header.example?.header_handle?.[0] || ""
                : "",

            // Body and example text
            message_body: body.text || "",
            example_body_text: body.example?.body_text || [], // Extracting example body text
            // Footer and security recommendations
            add_security_recommendation:
              body.add_security_recommendation || false,
            code_expiration_minutes: footer.code_expiration_minutes || null,
            footer: footer.text || "",

            buttons: buttons
              .map((element) => {
                if (element.type === "OTP") {
                  return {
                    type: element.type,
                    otp_type: element.otp_type,
                    supported_apps:
                      element.supported_apps?.map((app) => ({
                        package_name: app.package_name,
                        signature_hash: app.signature_hash,
                      })) || [],
                  };
                } else {
                  return {
                    type: element.type,
                    text: element.text,
                    ...(element.type === "PHONE_NUMBER" && {
                      phone_number: element.phone_number,
                    }),
                    ...(element.type === "URL" && { url: element.url }),
                  };
                }
              })
              .filter((item) => item.text && item.type),

            // Extracting button details
            // buttons: buttons.map(button => {
            //     if (button.type === 'OTP') {
            //         return {
            //             type: button.type,
            //             otp_type: button.otp_type,
            //             supported_apps: button.supported_apps?.map(app => ({
            //                 package_name: app.package_name,
            //                 signature_hash: app.signature_hash,
            //             })) || [],
            //         };
            //     } else {
            //         return {
            //             type: button.type,
            //             text: button.text,
            //             ...(button.type === 'PHONE_NUMBER' && { phone_number: button.phone_number }),
            //             ...(button.type === 'URL' && { url: button.url }),
            //         };
            //     }
            // }).filter(button => button.text && button.type),
            // Extracting button details
            // buttons: buttons.map(button => {
            //     return {
            //         type: button.type,
            //         text: button.text,
            //         ...(button.type === 'PHONE_NUMBER' && { phone_number: button.phone_number }),
            //         ...(button.type === 'URL' && { url: button.url }),
            //     };
            // }).filter(button => button.text && button.type),  // Only include valid buttons
          };
        });

        setAllTemplateData(transformedData);
        setFilteredTemplates(transformedData);
        setIsSpinner(true);
      }
      setIsSpinner(true);
    }
  };
  function generateOTP() {
    return Math.floor(100000 + Math.random() * 900000).toString();
  }

  const handleChange = async (event) => {
    const selectedName = event.target.value;
    setParameters({});
    setTemplateParms({});
    const template = allTemplateData.find((t) => t.id === selectedName);

    if (template) {
      if (template.template_type === "carousel") {
        setSelectedTemplateName(template);
        const buttonVars = getButtonVariables(template);
        setButtonVariableValues(
          buttonVars.reduce(
            (acc, v) => ({ ...acc, [v.variableIndex]: "" }),
            {},
          ),
        );
      } else {
        const {
          id,
          name,
          language,
          category,
          header,
          header_text,
          header_image_url,
          header_document_url,
          header_video_url,
          message_body,
          example_body_text,
          footer,
          buttons,
        } = template;
        // const exampleValue = example_body_text.length > 0 && example_body_text[0].length > 0 ? generateOTP() : '';
        const examplebodytext =
          category === "AUTHENTICATION" ? generateOTP() : "";

        const header_body =
          header_text ||
          header_image_url ||
          header_document_url ||
          header_video_url;
        const formattedTemplate = {
          id,
          name,
          language,
          category,
          header,
          header_body,
          message_body,
          example_body_text: examplebodytext,
          footer,
          buttons,
          business_number: selectedWhatsAppSetting,
        };
        setSelectedTemplateName(formattedTemplate);
        const buttonVars = getButtonVariables(formattedTemplate);
        setButtonVariableValues(
          buttonVars.reduce(
            (acc, v) => ({ ...acc, [v.variableIndex]: "" }),
            {},
          ),
        );
      }
    } else {
      setSelectedTemplateName();
      setButtonVariableValues({});
    }
  };

  async function fetchFile(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Network response was not ok");
    return await response.blob();
  }

  const handleParametersChange = (newParams) => {
    setParameters(newParams);
  };

  /** Returns list of button dynamic variables (e.g. {{1}}) for the given template */
  function getButtonVariables(template) {
    if (!template) return [];
    const seen = new Set();
    const result = [];

    const collectFromButtons = (buttons) => {
      if (!Array.isArray(buttons)) return;
      buttons.forEach((btn) => {
        const text = (btn.text || "").toString();
        const url = (btn.url || "").toString();
        const combined = `${text} ${url}`;
        const matches = combined.match(/\{\{(\d+)\}\}/g);
        if (matches) {
          matches.forEach((m) => {
            const variableIndex = m.replace(/\{\{|\}\}/g, "");
            if (!seen.has(variableIndex)) {
              seen.add(variableIndex);
              result.push({
                variableIndex,
                label: `Button value for {{${variableIndex}}}`,
              });
            }
          });
        }
      });
    };

    if (
      template.template_type === "carousel" &&
      Array.isArray(template.cards)
    ) {
      template.cards.forEach((card) => collectFromButtons(card.buttons));
    } else if (Array.isArray(template.buttons)) {
      collectFromButtons(template.buttons);
    }

    return result.sort(
      (a, b) => Number(a.variableIndex) - Number(b.variableIndex),
    );
  }

  //   const handleSubmit = async (event) => {
  //     try{

  //     event.preventDefault();

  //     let documentId = null;
  // let adminPhone = null;
  // setIsSpinner(false);
  // if (parameters.file) {
  //   const formData = new FormData();
  //   formData.append("messaging_product", "whatsapp");
  //   formData.append("file", parameters.file);
  //   formData.append("description", "Attachment");
  //       const  fileResult = await WhatsAppAPI.createFile(null, formData);

  // if(fileResult.success){
  //     documentId = fileResult.records[0].id;
  // }

  // }

  // parameters.file_id = documentId || parameters.file;
  // if (parameters.sendToAdmin && userInfo?.whatsapp_number) {
  //   adminPhone = userInfo?.whatsapp_number.match(/^\d{10}$/)
  //     ? `91${userInfo?.whatsapp_number}`
  //     : userInfo?.whatsapp_number;
  // }

  // parameters.whatsapp_number_admin = adminPhone || null;

  // setTemplateParms(parameters);
  // setshow(false)
  // setIsSpinner(true)
  // }catch(error){

  // }

  //   };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // console.log("parameters", parameters);
    // console.log("selected", selectedTemplateName);
    const cardDocIds = [];
    const cardFileResults = [];
    setIsSpinner(false);
    // ✅ Handle carousel card files if cards exist
    if (
      Array.isArray(selectedTemplateName.cards) &&
      selectedTemplateName.cards.length > 0
    ) {
      for (let idx = 0; idx < selectedTemplateName.cards.length; idx++) {
        const cardParams = parameters[idx] || {};
        let docId = null;
        let fileResult = null;

        if (cardParams.file && cardParams.file instanceof File) {
          const formData = new FormData();
          formData.append("messaging_product", "whatsapp");
          formData.append("file", cardParams.file);
          formData.append("description", `Carousel Card ${idx + 1} Attachment`);

          fileResult = await WhatsAppAPI.createFile(null, formData);

          if (fileResult?.records?.[0]?.id) {
            parameters[idx].file_id = fileResult.records[0].id;
            parameters[idx].file_title = fileResult.records[0].title;
          }
        } else if (cardParams.fileURL && cardParams.fileType) {
          try {
            const response = await fetch(cardParams.fileURL);
            const blob = await response.blob();
            const fileName = `carousel_card_${idx + 1}.${cardParams.fileType}`;
            const file = new File([blob], fileName, { type: blob.type });

            const formData = new FormData();
            formData.append("messaging_product", "whatsapp");
            formData.append("file", file);
            formData.append(
              "description",
              `Carousel Card ${idx + 1} Attachment`,
            );

            fileResult = await WhatsAppAPI.createFile(null, formData);

            if (fileResult?.records?.[0]?.id) {
              parameters[idx].file_id = fileResult.records[0].id;
              parameters[idx].file_title = fileResult.records[0].title;
            }
          } catch (error) {
            console.error(`Error processing file for card ${idx + 1}:`, error);
            toast.error(`Error processing file for card ${idx + 1}`);
          }
        }

        cardDocIds.push(docId);
        cardFileResults.push(fileResult);
      }
    }

    // ✅ If it's not a carousel, but a single media file
    if (parameters.file && parameters.file instanceof File) {
      try {
        const formData = new FormData();
        formData.append("messaging_product", "whatsapp");
        formData.append("file", parameters.file);
        formData.append("description", "Single Attachment");

        const fileResult = await WhatsAppAPI.createFile(null, formData);

        if (fileResult?.records?.[0]?.id) {
          parameters.file_id = fileResult.records[0].id;
          parameters.file_title = fileResult.records[0].title;
        }
      } catch (error) {
        console.error("Error uploading single media file:", error);
        toast.error("Error uploading media");
      }
    }

    const parametersWithButtons = {
      ...parameters,
      ...(Object.keys(buttonVariableValues).length > 0 && {
        button_variables: buttonVariableValues,
      }),
    };
    setTemplateParms(parametersWithButtons);
    setshow(false);
    setIsSpinner(true);
  };

  const { file, sendToAdmin, button_variables, ...filteredParams } = parameters;
  const matches =
    selectedTemplateName?.message_body?.match(/\{\{(\d+)\}\}/g) || [];
  const uniqueIndices = [];
  matches.forEach((match) => {
    const idx = match.replace(/\{\{|\}\}/g, "");
    if (!uniqueIndices.includes(idx)) uniqueIndices.push(idx);
  });
  const messageMatches = uniqueIndices;
  const bodyParamKeys = Object.keys(filteredParams).filter((k) =>
    /^\d+$/.test(k),
  );
  const hasExactMatch =
    JSON.stringify([...bodyParamKeys].sort()) ===
    JSON.stringify([...messageMatches].sort());
  const allValuesFilled =
    bodyParamKeys.length === 0 ||
    bodyParamKeys.every(
      (key) =>
        filteredParams[key] !== undefined &&
        filteredParams[key] !== null &&
        String(filteredParams[key]).trim() !== "",
    );
  const finalCheck = hasExactMatch && allValuesFilled;
  //   const isFormValid = Boolean(selectedTemplateName) && finalCheck;
  const requiresFile =
    selectedTemplateName?.header && selectedTemplateName?.header !== "TEXT";

  function isCarouselFormValid(selectedTemplateName, parameters) {
    if (!selectedTemplateName || !Array.isArray(selectedTemplateName.cards))
      return false;

    // Main body validation
    let mainValid = true;
    let mainMatches = [];
    let mainUniqueIndices = [];
    if (selectedTemplateName.message_body) {
      mainMatches =
        selectedTemplateName.message_body.match(/\{\{([^}]+)\}\}/g) || [];
      mainUniqueIndices = [
        ...new Set(mainMatches.map((m) => m.replace(/\{\{|\}\}/g, ""))),
      ];
      mainValid =
        mainUniqueIndices.length === 0 ||
        mainUniqueIndices.every(
          (idx) =>
            parameters.main &&
            typeof parameters.main[idx] === "string" &&
            parameters.main[idx].trim() !== "",
        );
    }

    // Cards validation
    let cardsValid = selectedTemplateName.cards.every((card, idx) => {
      const cardParams = parameters[idx] || {};

      // Check if card has file requirements
      const requiresFile = card.header_type && card.header_type !== "TEXT";
      const hasFile =
        cardParams.file &&
        (cardParams.file instanceof File ||
          (cardParams.fileURL && cardParams.fileType));

      // If card requires file but doesn't have one, it's invalid
      if (requiresFile && !hasFile) {
        return false;
      }

      // Check body text parameters
      const matches =
        (typeof card.body_text === "string" ? card.body_text : "").match(
          /\{\{([^}]+)\}\}/g,
        ) || [];
      const uniqueIndices = [
        ...new Set(matches.map((m) => m.replace(/\{\{|\}\}/g, ""))),
      ];

      const bodyParamsValid =
        uniqueIndices.length === 0 ||
        uniqueIndices.every(
          (paramIdx) =>
            cardParams[paramIdx] &&
            typeof cardParams[paramIdx] === "string" &&
            cardParams[paramIdx].trim() !== "",
        );

      return bodyParamsValid;
    });

    return mainValid && cardsValid;
  }

  function hasEmptyParameter(components) {
    return components.some(
      (comp) =>
        Array.isArray(comp.parameters) &&
        comp.parameters.some(
          (param) => typeof param.text === "string" && param.text.trim() === "",
        ),
    );
  }

  function hasEmptyParameterDeep(components) {
    // Check top-level components
    if (
      components.some(
        (comp) =>
          Array.isArray(comp.parameters) &&
          comp.parameters.some(
            (param) =>
              typeof param.text === "string" && param.text.trim() === "",
          ),
      )
    )
      return true;
    // Check carousel cards
    const carousel = components.find((comp) => comp.type === "carousel");
    if (carousel && Array.isArray(carousel.cards)) {
      return carousel.cards.some(
        (card) =>
          Array.isArray(card.components) &&
          card.components.some(
            (comp) =>
              Array.isArray(comp.parameters) &&
              comp.parameters.some(
                (param) =>
                  typeof param.text === "string" && param.text.trim() === "",
              ),
          ),
      );
    }
    return false;
  }

  const buttonVars = selectedTemplateName
    ? getButtonVariables(selectedTemplateName)
    : [];
  const buttonVarsFilled =
    buttonVars.length === 0 ||
    buttonVars.every(
      (v) => (buttonVariableValues[v.variableIndex] || "").trim() !== "",
    );

  const isFormValid =
    selectedTemplateName?.template_type === "carousel"
      ? isCarouselFormValid(selectedTemplateName, parameters) &&
        buttonVarsFilled
      : Boolean(selectedTemplateName) &&
        finalCheck &&
        (!requiresFile || Boolean(parameters.file)) &&
        buttonVarsFilled;

  return (
    <>
      <Modal show={show} animation={false} size="lg" centered>
        <Modal.Header closeButton onClick={onHide}>
          <Modal.Title id="contained-modal-title-vcenter">
            Send WhatsApp Template
          </Modal.Title>
        </Modal.Header>
        {isSpinner ? (
          <>
            <Modal.Body style={{ maxHeight: "70vh", overflow: "auto" }}>
              <Form noValidate>
                <Row className="p-2 mb-3">
                  <Col lg={12} sm={12} xs={12}>
                    {/* Category Filter Dropdown */}
                    <Form.Group className="mb-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="categoryFilter"
                      >
                        Select Template Category
                      </Form.Label>
                      <Form.Select
                        style={{ height: "36px" }}
                        aria-label="Select Template Category"
                        name="categoryFilter"
                        onChange={handleCategoryChange}
                      >
                        {categories.map((category) => (
                          <option key={category} value={category}>
                            {category}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={12} sm={12} xs={12}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        Template Name
                      </Form.Label>
                      <Form.Select
                        required
                        style={{ height: "36px" }}
                        aria-label="select name"
                        name="templateName"
                        onChange={handleChange}
                        placeholder="Select Template Name"
                        // value={templateName}
                      >
                        <option value="">Select Template Name</option>
                        {filteredTemplates?.map((template) => (
                          <option key={template.id} value={template.id}>
                            {template?.message_body?.match(/\{\{(\d+)\}\}/g)
                              ?.length > 0
                              ? `${template.templatename} {{-}} `
                              : template.templatename}

                            {/* {template.templatename} */}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={12} sm={12} xs={12}>
                    <TemplatePreview
                      template={selectedTemplateName}
                      onParametersChange={handleParametersChange}
                      //tamplateparms={tamplateparms}
                      setParameters={setParameters}
                      parameters={{
                        ...parameters,
                        ...(Object.keys(buttonVariableValues).length > 0 && {
                          button_variables: buttonVariableValues,
                        }),
                      }}
                    />
                    {selectedTemplateName &&
                      getButtonVariables(selectedTemplateName).length > 0 && (
                        <Form.Group className="mb-3 mt-2">
                          <Form.Label className="form-view-label">
                            Button dynamic values{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          {getButtonVariables(selectedTemplateName).map(
                            (btnVar) => (
                              <Form.Group
                                key={btnVar.variableIndex}
                                className="mb-2"
                              >
                                <Form.Label
                                  className="form-view-label small"
                                  style={{ marginBottom: "4px" }}
                                >
                                  {btnVar.label}{" "}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  required
                                  placeholder={`Enter value for {{${btnVar.variableIndex}}}`}
                                  value={
                                    buttonVariableValues[
                                      btnVar.variableIndex
                                    ] ?? ""
                                  }
                                  onChange={(e) =>
                                    setButtonVariableValues((prev) => ({
                                      ...prev,
                                      [btnVar.variableIndex]: e.target.value,
                                    }))
                                  }
                                />
                              </Form.Group>
                            ),
                          )}
                        </Form.Group>
                      )}
                  </Col>
                </Row>
              </Form>
            </Modal.Body>

            <Modal.Footer>
              <button className="btn btn-light" onClick={onHide}>
                Close
              </button>
              <button
                className="btn btn-outline-secondary"
                onClick={handleSubmit}
                disabled={!isFormValid}
              >
                Done
              </button>
            </Modal.Footer>
          </>
        ) : (
          <div className="sk-cube-grid">
            <div className="sk-cube sk-cube1"></div>
            <div className="sk-cube sk-cube2"></div>
            <div className="sk-cube sk-cube3"></div>
            <div className="sk-cube sk-cube4"></div>
            <div className="sk-cube sk-cube5"></div>
            <div className="sk-cube sk-cube6"></div>
            <div className="sk-cube sk-cube7"></div>
            <div className="sk-cube sk-cube8"></div>
            <div className="sk-cube sk-cube9"></div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default CampaignTemplateModal;
